import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { Calendar, CalendarModule } from 'primeng/calendar';
import { PreAssesmentComponent } from '../pre-assesment/pre-assesment.component';

@Component({
  selector: 'patient-booking-appoinment',
  imports: [Calendar, CommonModule, Button, CalendarModule, FormsModule, PreAssesmentComponent],
  templateUrl: './booking-appoinment.component.html',
  styleUrl: './booking-appoinment.component.css',
})
export class BookingAppoinmentComponent {
  showPreassement: boolean = true;
  showPreAssesmentQue: boolean = false;

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }

  startAssessment() {
    this.showPreAssesmentQue = true;
    this.showPreassement = false;
  }
}
